import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { format } from 'react-string-format';
import '../../../i18n'
import ReactHtmlParser from 'html-react-parser';
import Button from '../../UI/Buttons/Button';
import { useSearchParams } from 'react-router-dom';

export function ConfirmCancellation(props) {

    const { t, i18n } = useTranslation();
    const {endDate, orderId, userEmail } = props;
    const [refNoString, setRefNoString]= useState("");
    const [endDateString, setEndDateString]  = useState("");
    const [searchParams, setSearchParams] = useSearchParams();
    const [isLoading, setIsLoading] = useState(false);

    const redirectToMySubscriptionPage = () =>{

      
        let mySubsUrl = sessionStorage.getItem("subsPageUrl");
        if(mySubsUrl){
            setIsLoading(true);
            window.location.href= mySubsUrl;
        } 
    }

    useEffect(() => {

        if (orderId) {
          setRefNoString(
            format(t("cancellation.refno"), orderId)
          );
        }
      }, [ orderId, t]);
    
      useEffect(() => {
        if (endDate) {
          setEndDateString(
            format(t("cancellation.enddate"), endDate)
          );
        }
      }, [endDate, t]);

    return (
        <div className="container">
            
            <div className="item-container">
                <h1 class="block-header" tabindex="-1">{t("cancellation.confirmationtext")}</h1>
            </div>

            {userEmail ?
            <div className="item-container">
                <div className="item-wrapper">
                    <p>{format(t('cancellation.senttotext'), userEmail)}</p>
                    <p>{endDateString && ReactHtmlParser(endDateString || "")}</p>
                </div>
            </div> : ""}

            <div className="item-container">
                <div className="border-seperator"></div>
            </div>
            <div className="item-container ">
                <div className="item-wrapper one-row-items" >
                    <h2 className="module-heading">{t('cancellation.orderdetailslabel')}</h2>
                    <p className="large">{refNoString && ReactHtmlParser(refNoString || "")}</p>
                </div>
            </div>
            <div className="item-container">
                <div className="item-wrapper">
                    {isLoading ? <Button type="button" buttonSize="medium" hasIcon="updating">{t("cancellation.returntext")} </Button> :
                    <Button type="button" buttonSize="medium" onClick={(e)=>{redirectToMySubscriptionPage(e)}}>{t("cancellation.returntext")} </Button>}
                </div>
            </div>
        </div>

    );
}